import Button from '@ingka/button';
import Icon from '@ingka/ssr-icon';
import smallCheckSvg from '@ingka/ssr-icon/paths/checkmark-small';
import Text from '@ingka/text';
import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { getRetailUnitAndLanguage } from '../../network/utils/getRetailUnitAndLanguage';
import { isLoyaltyEnabled } from '../../utils/retailUnitsWithLoyalty';
import { getAuthServiceUrl, toUrl } from '../../utils/url';
import { PREFIX } from '../Skapa/constants/constants';
import { Linkouts } from './Linkouts';

import styles from './CiamLoginModalContent.module.scss';

export function CiamLoginModalContent() {
  const { t } = useTranslation('profile');

  const title = useMemo(() => {
    if (isLoyaltyEnabled) {
      return (
        <Trans
          i18nKey="menu.ciam.logInCreateFamilyAccount.title"
          ns="profile"
          components={[<span key="loyalty" className={styles.loyaltyColor} />]}
        />
      );
    }

    return t('loginPrompt.alternativeOption.header');
  }, [t]);

  const login = useMemo(() => {
    const { retailUnit, language: lang } = getRetailUnitAndLanguage();

    return toUrl(`${getAuthServiceUrl()}/login`, {
      lang,
      prompt: 'login',
      retailUnit,
      referrer: globalThis.location.href,
    });
  }, []);

  const signup = useMemo(() => {
    const { retailUnit, language: lang } = getRetailUnitAndLanguage();

    return toUrl(`${getAuthServiceUrl()}/signup`, {
      lang,
      retailUnit,
      referrer: globalThis.location.href,
    });
  }, []);

  return (
    <div>
      <Text
        prefix={PREFIX}
        tagName="h2"
        textStyle="Heading.L"
        className={styles.header}
        data-testid="login-sheet-header"
      >
        {title}
      </Text>
      {isLoyaltyEnabled ? (
        <ul className={styles.benefits}>
          {t('menu.ciam.familyBenefits.body')
            .split('|')
            .map((line) => (
              <li key={line}>
                <Icon prefix={PREFIX} paths={smallCheckSvg} aria-hidden="true" />
                <Text prefix={PREFIX} textStyle="Body.M" tagName="span">
                  {line.trim()}
                  <br />
                </Text>
              </li>
            ))}
        </ul>
      ) : (
        <Text prefix={PREFIX} tagName="p">
          {t('loginPage.loginPageHeaderDescription')}
        </Text>
      )}

      <Button
        className={styles.button}
        prefix={PREFIX}
        fluid
        href={login}
        data-testid="login"
        text={t('loginPage.loginButton')}
        type="primary"
      />
      <div className={styles.divider}>
        <Text prefix={PREFIX} tagName="span">
          {t('loginPrompt.newIkea.text')}
        </Text>
      </div>
      {isLoyaltyEnabled && (
        <Text prefix={PREFIX} tagName="p" className={styles.createFamilyAccountText}>
          {t('menu.ciam.createFamilyAccount')}
        </Text>
      )}
      <Button
        className={styles.button}
        prefix={PREFIX}
        fluid
        href={signup}
        data-testid="create-account"
        text={t('loginPage.createAccountButton')}
        type="secondary"
      />

      {isLoyaltyEnabled && <Linkouts />}
    </div>
  );
}
